export const getAsync = <T>(
  fn: (callback: (result: Office.AsyncResult<T>) => void) => void
): Promise<T> => {
  return new Promise((resolve, reject) => {
    fn((result: Office.AsyncResult<T>) => {
      if (result.status === Office.AsyncResultStatus.Succeeded) {
        resolve(result.value);
      } else {
        reject(new Error(result.error?.message || "Office API error"));
      }
    });
  });
};

export const isOfficeContextAvailable = (): boolean => {
  return Boolean(Office.context?.mailbox?.item);
};

export const isComposeMode = (item: Office.Item): boolean => {
  return typeof (item as Office.AppointmentCompose).subject?.getAsync === "function";
};
